"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPAREL_AXIS = exports.APPAREL_FEATURE = exports.PRODUCT_TYPE_IDS = void 0;
// Catalog product type ids. Stored on product.productTypeId and copied to
// every search document; code that special-cases a type compares against these.
exports.PRODUCT_TYPE_IDS = {
    PRODUCT_WITH_VARIANTS: 'type_product_with_variants',
    SINGLE_ITEM: 'type_single_item',
    APPAREL: 'type_apparel',
    WEIGHTED: 'type_weighted',
    NON_SCANNABLE: 'type_non_scannable',
    MENU_ITEM: 'type_menu_item',
    STORE_SUPPLY: 'type_store_supply',
    LOTTERY: 'type_lottery',
};
// Package feature that unlocks the Clothing & Accessories product type.
exports.APPAREL_FEATURE = 'apparel';
// Axis names used in product.optionAxes and variant.options for apparel.
exports.APPAREL_AXIS = { COLOR: 'Color', SIZE: 'Size' };
//# sourceMappingURL=productTypes.js.map